import { Link } from 'gatsby'
import { ResourceDropDownItem } from './data'

interface ResourcedDropdownProps {
  content: ResourceDropDownItem[]
}

const ResourcedDropdown = ({ content }: ResourcedDropdownProps) => {
  return (
    <div className="row nav-dropdown-menu-content">
      {content.map((item, index) => (
        <div
          key={`${item.to}-${index}`}
          className="col-xs-12 col-sm-6 resource-dropdown-item"
        >
          <Link to={item.to}>
            <h3 className="nav-dropdown-item-title">{item.title}</h3>
          </Link>
          <p className="resource-item-subtitle">{item.subtitle}</p>

          <div className="resource-featured-links">
            {item.featured && (
              <p className="resource-item-subtitle mb-0">Featured Articles:</p>
            )}

            {item.links.map((link, idx) => (
              <Link
                key={`${link.url}-${idx}`}
                to={link.url}
                className="resource-featured-link"
              >
                {link.title}
              </Link>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}

export default ResourcedDropdown
